import {
  DisplayProperties,
  GenericLabel,
  Image,
  Link
} from '@com-delta-omnichannel/aura';

export interface TooltipInfo extends Link {
  isIcon?: boolean;
  image?: Image;
  information?: string;
}

export interface TrackerFooter {
  total: GenericLabel;
  max: string;
  iconLink: TooltipInfo;
  spendLink: TooltipInfo;
  thresholdMet?: boolean;
}

export interface Visit {
  count?: number; // For the Number of Visits
  maxCount: number;
  title: string; // For the title of the card (eg.: Visits Available, Unlimited Access etc.)
  description?: string; // For the description of the card (eg.: Valid Through Jan 31, 2027 etc.)
  image?: Image; // For the image of the card
}

export interface CardType {
  name: string; // For the Card name (eg.: Delta SkyMiles® Reserve Business Amex Card)
  terms: TooltipInfo; // For the Terms link with the name with popover modal
}

export interface SkyClubCard {
  visit: Visit; // For the Visit Information
  type: CardType; // For the card type information
  thresholdMet?: boolean; // For the color code and background, in-case of Hit $75k
  spendTracker?: TrackerFooter; // For the Tracker information
  searchEligibleFooter?: TooltipInfo; // If the user has a Sky Club Membership, we will display “search for eligible Sky Clubs” link that takes the user to the Sky Club Search page on the app.
}
export interface TrackerAriaLabels {
  next: string;
  previous: string;
}

export interface SkyClubSpendTracker extends DisplayProperties {
  headerLogo: Image;
  cards: SkyClubCard[];
  ariaLabels?: TrackerAriaLabels; // In-case cards array has more than and equals to 2
}
